import script from "./OrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=51e1e829&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e1e829"]])

export default __exports__